import React from 'react';
import { ReactComponent as Image } from 'svg/illustrations/undraw_hologram_fjwp.svg';
import Hero from 'components/hero';
import EmployerBenefit from './employer-benefit';
import './style.css';

const EmployerBenefits = () => {
  return (
    <Hero layout="vertical" className="bg-grey">
      <h2>MyShifts is revolutionary</h2>
      <p className="text-center">
        MyShifts was created by industry experts to put you totally in control
        of everything connected to recruiting for vacant Shifts.
      </p>

      <section className="employer-benefits">
        <div className="employer-benefits-list-1">
          <EmployerBenefit title="We are a totally independent 'connection' service." />
          <EmployerBenefit title="We don't hold onto any money in order to create profit." />
          <EmployerBenefit title="We are not a Recruitment Agency." />
          <EmployerBenefit title="MyShifts is a very quick connection service. No waiting for Recruitment Agencies to call you back!" />
        </div>

        <Image className="home-illustration" />

        <div className="employer-benefits-list-2">
          <EmployerBenefit
            title="We have the UK's biggest 'Bank Worker' database."
            isLeft
          />
          <EmployerBenefit
            title="We don't directly employ any staff, Nurses, care workers etc."
            isLeft
          />
          <EmployerBenefit
            title="We don't make vast fees in 'connecting' you with workers."
            isLeft
          />
          <EmployerBenefit
            title="MyShifts enables employers to remain compliant with regulators during the temporary worker recruitment process."
            isLeft
          />
        </div>
      </section>
    </Hero>
  );
};

export default EmployerBenefits;
